/**
 * @fileoverview GET handler for the "/app_settings/segmentable_property_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsSegmentablePropertyUsage } from "./constants";
import type { AppSettingsSegmentablePropertyUsageResult, SegmentablePropertyUsageProps } from "./types";
import { isAppSettingsSegmentablePropertyUsageResult } from "./validators";

export const getAppSettingsSegmentablePropertyUsage = reactQueryFetcherAdapter(
  appSettingsSegmentablePropertyUsage,
  (
    signal: AbortSignal,
    props: SegmentablePropertyUsageProps
  ): Promise<AppSettingsSegmentablePropertyUsageResult> => {
    return fetch("/app_settings/segmentable_property_usage", "GET", props, { signal });
  },
  isAppSettingsSegmentablePropertyUsageResult
);
